import { Directive } from "@angular/core";

@Directive({
  // tslint:disable-next-line
  selector: "[isDeveloper]"
})
export class IsDeveloperDirective {
  constructor() {}
}
